import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EuroSymbolIcon(props: IconProps) {
    return <Icon {...props} iconKey={"euro_symbol"}/>
}
